import { ref } from 'vue'

// Same localStorage key index.html's own inline splash-screen script reads/writes
// (see gleaming-wibbling-otter.md) — seeding from it here means the app doesn't
// flash from "cached logo" (splash) to "no logo" to "fetched logo" (app) on mount.
const CACHE_KEY = 'tenant_branding'

function readCache() {
  try {
    return JSON.parse(localStorage.getItem(CACHE_KEY) || 'null')
  } catch {
    return null
  }
}

const cached = readCache()

// Module-level cache — same for the whole session/domain, so every component
// that calls useTenantBranding() shares one fetch instead of re-requesting.
const name = ref(cached?.name || '')
const logoUrl = ref(cached?.logoUrl || '')
const acronym = ref(cached?.acronym || 'BMA')
const tosUrl = ref(cached?.tosUrl || '')
const policiesUrl = ref(cached?.policiesUrl || '')
const hostname = ref(cached?.hostname || '')
const faviconAdminUrl = ref(cached?.faviconAdminUrl || '')
const faviconTokenUrl = ref(cached?.faviconTokenUrl || '')
const faviconDashboardUrl = ref(cached?.faviconDashboardUrl || '')
let fetched = false
let inFlight = null

async function fetchBranding() {
  if (fetched) return
  if (!inFlight) {
    inFlight = fetch('/api/tenant/branding')
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (data) {
          name.value = data.name || ''
          logoUrl.value = data.logo_url || ''
          acronym.value = data.acronym || data.name || 'BMA'
          tosUrl.value = data.tos_url || ''
          policiesUrl.value = data.policies_url || ''
          hostname.value = data.hostname || ''
          faviconAdminUrl.value = data.favicon_admin_url || ''
          faviconTokenUrl.value = data.favicon_token_url || ''
          faviconDashboardUrl.value = data.favicon_dashboard_url || ''
          try {
            localStorage.setItem(CACHE_KEY, JSON.stringify({
              name: data.name, logoUrl: data.logo_url, acronym: acronym.value,
              tosUrl: tosUrl.value, policiesUrl: policiesUrl.value, hostname: hostname.value,
              faviconAdminUrl: faviconAdminUrl.value, faviconTokenUrl: faviconTokenUrl.value,
              faviconDashboardUrl: faviconDashboardUrl.value,
            }))
          } catch {}
        }
        fetched = true
      })
      .catch(() => {
        fetched = true
      })
  }
  return inFlight
}

export function useTenantBranding() {
  fetchBranding()
  return {
    name, logoUrl, acronym, tosUrl, policiesUrl, hostname,
    faviconAdminUrl, faviconTokenUrl, faviconDashboardUrl,
  }
}
